<script setup>
import { onMounted, ref } from "vue";
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import { CountTo } from "vue3-count-to";
import { authHeader } from "../../helpers/authservice/auth-header";
import axios from "axios";

const user = JSON.parse(localStorage.getItem("user"));
const lgus = ref([]);

const selectedLGU = ref(null);
const selectedLGUName = ref("All");

const title = ref("Dashboard");
const items = ref([
  {
    text: "Home",
    href: "/",
  },
  {
    text: "Dashboard",
    active: true,
  },
]);

const user_processed = ref({
  inputs: 0,
  verifies: 0,
  validates: 0,
  approves: 0,
  rejects: 0,
});

const selectedDateRange = ref("today");
const date_range_filters = ref([
  { value: "today", text: "Today" },
  { value: "weekly", text: "Weekly" },
  { value: "monthly", text: "Monthly" },
]);

const lgu_processed = ref({
  inputs: 0,
  input_rejects: 0,
  verifies: 0,
  verify_rejects: 0,
  validates: 0,
  validate_rejects: 0,
  approves: 0,
  approve_rejects: 0,
  // approvals: 0,
  // rejected: 0,
});

const lgu_backlogs = ref({
  to_be_process: 0,
  pending_inputs: 0,
  pending_verifies: 0,
  pending_validates: 0,
  pending_lgu_approve: 0,
});

const getUserLGU = async () => {
  try {
    const { data } = await axios.get(`users/${user.id}`, {
      headers: authHeader(),
    });

    if (data.user && data.user.lgus) {
      lgus.value = data.user.lgus;
    }
  } catch (err) {
    console.log(err);
  }
};

const getLGUProcessedAndBackLogs = (id) => {
  selectedLGUName.value = getLGUName(id);
  getLGUProcessed(id);
  getLGUBacklogs(id);
};

const getUserProcessed = async () => {
  try {
    const response = await axios.get("/dashboard/backlogs", {
      params: {
        dateRange: selectedDateRange.value,
      },
      headers: authHeader(),
    });

    user_processed.value = response.data;
  } catch (err) {
    console.log(err);
  }
};

const getLGUProcessed = async (id) => {
  try {
    if (id === "all") {
      lgu_processed.value = {
        inputs: 14324,
        verifies: 14232,
        validates: 1232,
        approves: 11233,
      };
      return;
    }

    const response = await axios.get("/dashboard/lguProcessed", {
      params: {
        lgu_id: id,
      },
      headers: authHeader(),
    });

    lgu_processed.value = response.data;
  } catch (err) {
    console.log(err);
  }
};

const getLGUBacklogs = async (id) => {
  try {
    if (id === "all") {
      lgu_backlogs.value = {
        inputs: 14324,
        verifies: 14232,
        validates: 1232,
        approves: 11233,
      };
      return;
    }

    const response = await axios.get("/dashboard/lguBacklogs", {
      params: {
        lgu_id: id,
      },
      headers: authHeader(),
    });

    lgu_backlogs.value = response.data;
  } catch (err) {
    console.log(err);
  }
};

const getLGUName = (id) => {
  if (lgus.value.length > 0) {
    const lgu = lgus.value.find((el) => el.id === id);
    return lgu.name;
  }
  return "N/A";
};

const clearReloadInterval = (interval) => window.clearInterval(interval);

const handleOnChangeDateRange = () => {
  getUserProcessed();
};

const setReloadInterval = () =>
  window.setInterval(() => {
    getUserProcessed();

    if (lgus.value.length) {
      getLGUProcessedAndBackLogs(selectedLGU.value);
    }
    clearReloadInterval(setReloadInterval);
  }, 60000);

onMounted(async () => {
  await getUserLGU();
  await getUserProcessed();

  if (lgus.value.length) {
    selectedLGU.value = lgus.value[0].id;
    getLGUProcessedAndBackLogs(selectedLGU.value);
  }

  setReloadInterval();
});
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="h-100">
          <div class="row mb-3 pb-1">
            <div class="col-12 d-flex justify-content-between">
              <!-- <div class="d-flex align-items-lg-center flex-column"> -->
              <div class="flex-grow-1">
                <h4 class="fs-16 mb-1">Hi, {{ user.name }}</h4>
                <p class="text-muted mb-0">Here's your current progress</p>
              </div>
              <!-- </div> -->
              <!-- <div class=""> -->
              <div class="d-flex justify-content-end">
                <select
                  class="form-select"
                  v-model="selectedDateRange"
                  name="dateRange"
                  id=""
                  @change="handleOnChangeDateRange"
                >
                  <option
                    v-for="item in date_range_filters"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </option>
                  <!-- <option value="today">Today</option> -->
                  <!-- <option value="weekly">Weekly</option> -->
                  <!-- <option value="monthly">Monthly</option> -->
                </select>
              </div>
              <!-- </div> -->
            </div>
          </div>

          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="card card-animate">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 overflow-hidden">
                      <p
                        class="text-uppercase fw-medium text-muted text-truncate mb-0"
                      >
                        Total {{ $t("t-input-plate-no") }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-end justify-content-between mt-4"
                  >
                    <div>
                      <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                        <count-to
                          :startVal="0"
                          :endVal="user_processed.inputs"
                          :duration="1000"
                        ></count-to>
                      </h4>
                    </div>
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-success rounded fs-3">
                        <i class="bx bx-package"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- end card body -->
              </div>
            </div>
            <!-- end of col -->

            <div class="col-xl-3 col-md-6">
              <div class="card card-animate">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 overflow-hidden">
                      <p
                        class="text-uppercase fw-medium text-muted text-truncate mb-0"
                      >
                        Total 1st Review
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-end justify-content-between mt-4"
                  >
                    <div>
                      <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                        <count-to
                          :startVal="0"
                          :endVal="user_processed.verifies"
                          :duration="1000"
                        ></count-to>
                      </h4>
                    </div>
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-info rounded fs-3">
                        <i class="bx bx-glasses-alt"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- end card body -->
              </div>
            </div>
            <!-- end of col -->

            <div class="col-xl-3 col-md-6">
              <div class="card card-animate">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 overflow-hidden">
                      <p
                        class="text-uppercase fw-medium text-muted text-truncate mb-0"
                      >
                        Total 2nd Review
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-end justify-content-between mt-4"
                  >
                    <div>
                      <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                        <count-to
                          :startVal="0"
                          :endVal="user_processed.validates"
                          :duration="1000"
                        ></count-to>
                      </h4>
                    </div>
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-warning rounded fs-3">
                        <i class="bx bxs-wine"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- end card body -->
              </div>
            </div>
            <!-- end of col -->

            <!-- <div class="col-xl-3 col-md-6"> -->
            <!--   <div class="card card-animate"> -->
            <!--     <div class="card-body"> -->
            <!--       <div class="d-flex align-items-center"> -->
            <!--         <div class="flex-grow-1 overflow-hidden"> -->
            <!--           <p -->
            <!--             class="text-uppercase fw-medium text-muted text-truncate mb-0" -->
            <!--           > -->
            <!--             Total LGU Approves -->
            <!--           </p> -->
            <!--         </div> -->
            <!--       </div> -->
            <!--       <div -->
            <!--         class="d-flex align-items-end justify-content-between mt-4" -->
            <!--       > -->
            <!--         <div> -->
            <!--           <h4 class="fs-22 fw-semibold ff-secondary mb-4"> -->
            <!--             <count-to -->
            <!--               :startVal="0" -->
            <!--               :endVal="user_processed.approves" -->
            <!--               :duration="1000" -->
            <!--             ></count-to> -->
            <!--           </h4> -->
            <!--         </div> -->
            <!--         <div class="avatar-sm flex-shrink-0"> -->
            <!--           <span class="avatar-title bg-danger rounded fs-3"> -->
            <!--             <i class="bx bx-check-double"></i> -->
            <!--           </span> -->
            <!--         </div> -->
            <!--       </div> -->
            <!--     </div> -->
            <!--     <!-1- end card body -1-> -->
            <!--   </div> -->
            <!-- </div> -->
            <!-- <!-1- end of col -1-> -->

            <div class="col-xl-3 col-md-6">
              <div class="card card-animate">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1 overflow-hidden">
                      <p
                        class="text-uppercase fw-medium text-muted text-truncate mb-0"
                      >
                        Total {{ $t("t-input-plate-no") }} Processed (A/R)
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-end justify-content-between mt-4"
                  >
                    <div class="d-flex">
                      <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                        <count-to
                          :startVal="0"
                          :endVal="user_processed.approves"
                          :duration="1000"
                        ></count-to>
                      </h4>
                      <h4>/</h4>
                      <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                        <count-to
                          :startVal="0"
                          :endVal="user_processed.rejects"
                          :duration="1000"
                        ></count-to>
                      </h4>
                    </div>
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title bg-danger rounded fs-3">
                        <i class="bx bx-check-double"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- end card body -->
              </div>
            </div>
            <!-- end of col -->
          </div>
          <!-- end of row -->

          <div v-if="lgus.length > 0" class="row mb-3 pb-1">
            <div class="col-12">
              <div class="d-flex align-items-lg-center flex-lg-row flex-column">
                <div class="flex-grow-1">
                  <h4 class="fs-16 mb-1">Show LGU Progress</h4>
                  <p class="text-muted mb-0">Click LGU to filter</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Outlined Styles -->
          <div v-if="lgus.length > 0" class="hstack gap-2 flex-wrap mb-3">
            <span v-for="(lgu, index) in lgus" :key="lgu.id">
              <input
                v-model="selectedLGU"
                @change.prevent="getLGUProcessedAndBackLogs(lgu.id)"
                :value="lgu.id"
                type="radio"
                class="btn-check"
                :name="`options-outlined-${index}`"
                :id="`success-outlined-${index}`"
              />
              <label
                class="btn btn-outline-primary btn-rounded shadow-none"
                :for="`success-outlined-${index}`"
                >{{ lgu.name }}</label
              >
            </span>
            <!-- <span>
              <input @click.prevent="getLGUProcessed('all')" v-model="selectedLGU" value="all" type="radio" class="btn-check" name="options-outlined-all" id="success-outlined-all">
              <label class="btn btn-outline-primary btn-rounded shadow-none" for="success-outlined-all">All</label>
            </span> -->
          </div>

          <div class="row">
            <div v-if="lgus.length > 0" class="col-xl-6 col-md-12">
              <div class="card card-rounded p-3 card-height-100">
                <div class="card-header border-0 align-items-center d-flex">
                  <h4 class="card-title mb-0 flex-grow-1">
                    {{ selectedLGUName }} LGU Progress
                    {{ selectedLGUName === "All" ? "(Coming Soon)" : "" }}
                  </h4>
                </div>
                <!-- end cardheader -->
                <div class="card-body">
                  <ul
                    class="list-group list-group-flush border-dashed mb-0 mt-3 pt-2"
                  >
                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-success p-1 rounded-circle shadow"
                          >
                            <i class="bx bx-package fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Total {{ $t("t-input-plate-no") }} (A/R)</h6>
                        </div>
                        <!-- <div class="flex-shrink-0 text-end"> -->
                        <div class="d-flex">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.inputs"
                              :duration="1000"
                            ></count-to>
                            /
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.input_rejects"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-info p-1 rounded-circle shadow"
                          >
                            <i class="bx bx-glasses-alt fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Total 1st Review (A/R)</h6>
                        </div>
                        <!-- <div class="flex-shrink-0 text-end"> -->
                        <div class="d-flex">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.verifies"
                              :duration="1000"
                            ></count-to>
                            /
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.verify_rejects"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-warning p-1 rounded-circle shadow"
                          >
                            <i class="bx bxs-wine fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Total 2nd Review (A/R)</h6>
                        </div>
                        <!-- <div class="flex-shrink-0 text-end"> -->
                        <div class="d-flex">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.validates"
                              :duration="1000"
                            ></count-to>
                            /
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.validate_rejects"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-danger p-1 rounded-circle shadow"
                          >
                            <i class="bx bx-check-double fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Total Approved (A/R)</h6>
                        </div>
                        <!-- <div class="flex-shrink-0 text-end"> -->
                        <div class="d-flex">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.approves"
                              :duration="1000"
                            ></count-to>
                            /
                            <count-to
                              :startVal="0"
                              :endVal="lgu_processed.approve_rejects"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <!-- <li class="list-group-item px-0"> -->
                    <!--   <div class="d-flex"> -->
                    <!--     <div class="flex-shrink-0 avatar-xs"> -->
                    <!--       <span -->
                    <!--         class="avatar-title bg-danger p-1 rounded-circle shadow" -->
                    <!--       > -->
                    <!--         <i class="bx bx-check-double fs-16"></i> -->
                    <!--       </span> -->
                    <!--     </div> -->
                    <!--     <div class="flex-grow-1 ms-2 align-self-center"> -->
                    <!--       <h6 class="mb-1">Total LGU Approval</h6> -->
                    <!--     </div> -->
                    <!--     <div class="flex-shrink-0 text-end"> -->
                    <!--       <h6 class="mb-1"> -->
                    <!--         <count-to -->
                    <!--           :startVal="0" -->
                    <!--           :endVal="lgu_processed.approvals" -->
                    <!--           :duration="1000" -->
                    <!--         ></count-to> -->
                    <!--       </h6> -->
                    <!--     </div> -->
                    <!--   </div> -->
                    <!-- </li> -->

                    <!-- <li class="list-group-item px-0"> -->
                    <!--   <div class="d-flex"> -->
                    <!--     <div class="flex-shrink-0 avatar-xs"> -->
                    <!--       <span -->
                    <!--         class="avatar-title bg-danger p-1 rounded-circle shadow" -->
                    <!--       > -->
                    <!--         <i class="bx bx-check-double fs-16"></i> -->
                    <!--       </span> -->
                    <!--     </div> -->
                    <!--     <div class="flex-grow-1 ms-2 align-self-center"> -->
                    <!--       <h6 class="mb-1">Total LGU Approved</h6> -->
                    <!--     </div> -->
                    <!--     <div class="flex-shrink-0 text-end"> -->
                    <!--       <h6 class="mb-1"> -->
                    <!--         <count-to -->
                    <!--           :startVal="0" -->
                    <!--           :endVal="lgu_processed.approves" -->
                    <!--           :duration="1000" -->
                    <!--         ></count-to> -->
                    <!--       </h6> -->
                    <!--     </div> -->
                    <!--   </div> -->
                    <!-- </li> -->
                    <!-- <!-1- end -1-> -->

                    <!-- <li class="list-group-item px-0"> -->
                    <!--   <div class="d-flex"> -->
                    <!--     <div class="flex-shrink-0 avatar-xs"> -->
                    <!--       <span -->
                    <!--         class="avatar-title bg-danger p-1 rounded-circle shadow" -->
                    <!--       > -->
                    <!--         <i class="bx bx-check-double fs-16"></i> -->
                    <!--       </span> -->
                    <!--     </div> -->
                    <!--     <div class="flex-grow-1 ms-2 align-self-center"> -->
                    <!--       <h6 class="mb-1">Total Rejected</h6> -->
                    <!--     </div> -->
                    <!--     <div class="flex-shrink-0 text-end"> -->
                    <!--       <h6 class="mb-1"> -->
                    <!--         <count-to -->
                    <!--           :startVal="0" -->
                    <!--           :endVal="lgu_processed.rejected" -->
                    <!--           :duration="1000" -->
                    <!--         ></count-to> -->
                    <!--       </h6> -->
                    <!--     </div> -->
                    <!--   </div> -->
                    <!-- </li> -->
                    <!-- <!-1- end -1-> -->
                  </ul>
                  <!-- end -->
                </div>
                <!-- end card body -->
              </div>
              <!-- end card -->
            </div>

            <div v-if="lgus.length > 0" class="col-xl-6 col-md-12">
              <div class="card card-rounded p-3 card-height-100">
                <div class="card-header border-0 align-items-center d-flex">
                  <h4 class="card-title mb-0 flex-grow-1">
                    {{ selectedLGUName }} LGU Backlogs
                    {{ selectedLGUName === "All" ? "(Coming Soon)" : "" }}
                  </h4>
                </div>
                <!-- end cardheader -->
                <div class="card-body">
                  <ul
                    class="list-group list-group-flush border-dashed mb-0 mt-3 pt-2"
                  >
                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-success p-1 rounded-circle shadow"
                          >
                            <i class="bx bx-package fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Pending {{ $t("t-input-plate-no") }}</h6>
                        </div>
                        <div class="flex-shrink-0 text-end">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="
                                lgu_backlogs.to_be_process +
                                lgu_backlogs.pending_inputs
                              "
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-info p-1 rounded-circle shadow"
                          >
                            <i class="bx bx-glasses-alt fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Pending 1st Review</h6>
                        </div>
                        <div class="flex-shrink-0 text-end">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_backlogs.pending_verifies"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-warning p-1 rounded-circle shadow"
                          >
                            <i class="bx bxs-wine fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Pending 2nd Review</h6>
                        </div>
                        <div class="flex-shrink-0 text-end">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_backlogs.pending_validates"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->

                    <li class="list-group-item px-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0 avatar-xs">
                          <span
                            class="avatar-title bg-danger p-1 rounded-circle shadow"
                          >
                            <i class="bx bx-check-double fs-16"></i>
                          </span>
                        </div>
                        <div class="flex-grow-1 ms-2 align-self-center">
                          <h6 class="mb-1">Pending LGU Approval</h6>
                        </div>
                        <div class="flex-shrink-0 text-end">
                          <h6 class="mb-1">
                            <count-to
                              :startVal="0"
                              :endVal="lgu_backlogs.pending_lgu_approve"
                              :duration="1000"
                            ></count-to>
                          </h6>
                        </div>
                      </div>
                    </li>
                    <!-- end -->
                  </ul>
                  <!-- end -->
                </div>
                <!-- end card body -->
              </div>
              <!-- end card -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
